import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./styles/zeroing_out.css";
import "./styles/home_page/desktop/basic_style.css";
import "./styles/home_page/desktop/header_style.css";
import "./styles/home_page/desktop/tariffs_style.css";
import "./styles/home_page/desktop/manual_style.css";
import "./styles/home_page/desktop/form_registration_style.css";
import "./styles/home_page/desktop/basement_style.css";
import "./styles/home_page/fonts.css";
import "./styles/home_page/mobile/basic_style.css";
import "./styles/home_page/mobile/header_style.css";
import "./styles/home_page/mobile/tariffs_style.css";
import "./styles/home_page/mobile/manual_style.css";
import "./styles/home_page/mobile/form_registration_style.css";
import "./styles/home_page/mobile/basement_style.css";
import "./styles/home_page/desktop/curtains_style.css";
import "./styles/home_page/mobile/curtains_style.css";
import "./styles/home_page/desktop/dark_topic_style.css";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);

